export default "__VITE_ASSET__Oqw0JbhX__"